module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('p', {
    staticClass: "content-c",
    attrs: {
      "id": "calibre_toc_7"
    }
  }, [_c('a', {
    attrs: {
      "id": "b5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_004#a5"
    }
  }, [_c('span', {
    staticClass: "bold5"
  }, [_vm._v("Chapter One")])])]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "alt": "16658.png",
      "src": "OEBPS/image/16658.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chapter-name"
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_004#a5"
    }
  }, [_vm._v("The Root of the Rut ~ The Inside Out Approach to Healing")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1st-paragraph"
  }, [_vm._v("What is a life rut? A life rut is like supergluing your feet to the hardwood floor in the gym after your high school basketball game. Everyone else goes home, but you are stuck there all night. You are tired and you are hungry. You want to pee, lie down, and do something different, but you can’t. You don’t know how. This is all you know until you figure out how to get help and where this gluey mess all started. How do we get stuck in a life rut in the first place? It begins with the subtle or not so subtle experience of feeling "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("less than.")]), _vm._v(" Perhaps, when you were really young, like toddler age to seven or so, you were made to feel that you were not good enough at something. It may not have always been expressed blatantly, but you may have perceived this message"), _c('span'), _vm._v("anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("How do we recognize those times in our lives when we are in a"), _c('span'), _vm._v("rut?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("One symptom of a life rut may be that we stay at the same position at work for years, do the work of our supervisors, and do not ask for recognition, a raise, or a new position for far too long. What are we really afraid of? Where does this come from? Another symptom of a rut may be when we make the decision (over and over) to choose vegetables over fried foods when eating away from home, but then within a couple of weeks find ourselves back at the happy hour buffet eating the fried mozzarella with coworkers because we allow ourselves to sabotage our promises to ourselves. Whose path are we on anyway? We are practicing the same negative behaviors over and over again and we are not serving our higher purpose in life, or our immediate promises to ourselves. That is a rut. What and where does the rut come from"), _c('span'), _vm._v("originally?")]), _vm._v(" "), _c('p', {
    staticClass: "glyphs"
  }, [_c('img', {
    staticClass: "frame5",
    attrs: {
      "alt": "16682.png",
      "src": "OEBPS/image/16682.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "headings"
  }, [_c('span', {
    staticClass: "lowercase"
  }, [_vm._v("June’s Story: feeling unrooted was the root of her rut")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1st-paragraph"
  }, [_vm._v("My friend June could not keep a job as a butcher. She was a fabulous master carver, and all the chefs in her city loved her sing-song voice and her masterful skills with the knife. They followed her around from butcher shop to butcher shop, because she only worked for the finest places, and the meat she carved was of the highest quality. Truth be told, June bucked authority like no one I had ever seen. She either quit or was fired from 16 butcher shops within six years. Over steaming cups of coffee, I had a heart to heart with June one day, asking her why she could not keep a job she obviously loved so"), _c('span'), _vm._v("much.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“The root of my rut is I have no roots. I mean, I "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("feel")]), _vm._v(" like I have no roots. I was adopted as an infant from an orphanage in Thailand and my parents here kept telling me how lucky I was to have them, how grateful I should be. I am grateful, and I love them, but I feel like something is missing. I don’t feel grounded. I know I am in a rut. I keep doing the same thing over and over again. I recognize I am self-sabotaging my career, which I love. I want to find out who my birth parents are. I want to feel my roots or have closure and tie up the roots once and for all. I want to meet my birth parents if they are alive and have a connection. I want to see the orphanage in Thailand, if it still"), _c('span'), _vm._v("exists.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("June saved her money from the time we spoke and within six months she had enough for a one month trip to Thailand to fulfill her dreams. She came back to the United States an empowered woman, after having seen her birthplace and met her birth parents for the first time. They were dirt poor, they had three other children to care for, and had no way of caring for her. They could not afford birth control either, but clearly loved each other. June was born in June, hence the name. She met her siblings for the first time. Two other siblings were born after June, and they too were brought to the orphanage and put up for adoption. She emails her family members regularly now, and has kept the same butcher position with the same company for three years. She feels grounded and whole at last. Even though she is in one place, she is definitely unstuck and out of her rut of either quitting or being fired from jobs. She is at peace with herself because she knows where she comes"), _c('span'), _vm._v("from.")]), _vm._v(" "), _c('p', {
    staticClass: "glyphs"
  }, [_c('img', {
    staticClass: "frame5",
    attrs: {
      "alt": "16682.png",
      "src": "OEBPS/image/16682.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center_img"
  }, [_c('img', {
    attrs: {
      "alt": "qoutes",
      "src": "OEBPS/image/4.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1st-paragraph"
  }, [_vm._v("Did your parents or teachers imply that straight A’s were the only grades worth striving for? Mine did. Were you pushed to be the star athlete, a musical prodigy, or an ace at something? Were you constantly being compared to others in your family who were around the same age? If you didn’t live up to those expectations, perhaps you put yourself down internally, even if your elders didn’t criticize you openly. If you don’t unlock the cause of the emotional distress, you will likely end up chasing your own tail for years. Elements of feeling judged by others "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("or ")]), _vm._v("negatively judging"), _c('em', {
    staticClass: "italic"
  }), _vm._v("ourselves can have a profound effect on our mental and physical"), _c('span'), _vm._v("health.")]), _vm._v(" "), _c('p', {
    staticClass: "glyphs"
  }, [_c('img', {
    staticClass: "frame5",
    attrs: {
      "alt": "16682.png",
      "src": "OEBPS/image/16682.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "headings"
  }, [_c('span', {
    staticClass: "lowercase"
  }, [_vm._v("My Story: food equaled love - and I was loved a lot (the root of my rut)")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1st-paragraph"
  }, [_vm._v("When my grades were all A’s, my parents showered me with food, love, and praise, and shared my accolades with our relatives and their adult friends. The longer I maintained my A average (my entire K-12 education), the more they treated me to meals out, desserts, candies, and treats. Boy did that backfire. At age 12, I stood five feet two inches tall and weighed 173 pounds. "), _c('span', {
    staticClass: "bold1"
  }, [_vm._v("Food equaled love")]), _vm._v(". So, when I finally got it together on the food front, emotionally, my mom and dad viewed my clean eating as a rejection of their love, even though analytically they realized it was a smart thing their obese daughter was doing (by changing her eating"), _c('span'), _vm._v("habits).")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I did not want to hurt their feelings and reject their years of love and accolades as I was learning how to eat real food without processed carbohydrates, refined sugars, hydrolyzed oils, chemical additives, and"), _c('span'), _vm._v("preservatives.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Food equaled love")]), _vm._v(". Let’s go deeper into the root of my rut. Specifically, the kinds of foods that were just coming out in the late 1960s and 1970s were packaged convenience foods, made to last on the store shelves longer, made to be cooked in the oven or microwave within minutes, and made to help make a busy, working mom and wife’s life easier. My mother was very busy, as I was the youngest of five"), _c('span'), _vm._v("children.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("My parents grew up during the Depression era and they had to deal with less food and more day to day survival issues than I did while growing up. In their eyes, when I rejected their abundance of convenient and modern foods, I was saying "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("no")]), _vm._v(" to their success and their struggles of that era. Basically, I was rejecting their memories without knowing it. It felt to them like I was silently belittling their ordeal during those"), _c('span'), _vm._v("times.")]), _vm._v(" "), _c('p', {
    staticClass: "glyphs"
  }, [_c('img', {
    staticClass: "frame5",
    attrs: {
      "alt": "16682.png",
      "src": "OEBPS/image/16682.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "headings"
  }, [_c('span', {
    staticClass: "lowercase"
  }, [_vm._v("Our Relationship With Our Body: start here")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1st-paragraph"
  }, [_vm._v("A common rut in the United States of America is our uneven relationship with our bodies. Our skewed thinking between mind and body becomes our behavior around food. I was not alone in my behavior during the era of the snack food, fast food, convenient food, and junk food boom of the 1970s and 1980s. The root of this behavioral rut may start with our relationship with our body. We may be uncomfortable with the body changes that occurred when we were in our preteens. The hormonal changes made our scent, body shape, hair, and emotions change. We were not in control of our food choices while we were kids. Our parents made all the food choices for us, for our own good (or so they thought). If they were listening to the mainstream dietary advice of the time, they were following the Standard American Diet. The packaged, processed foods included in that recommended eating style contributed to our hormonal, metabolic, and behavioral downfall. Those foods are specifically produced so as to make us want more of"), _c('span'), _vm._v("them.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When I was fifty pounds heavier, I was so happy to find unusual earrings, or to find shoes that were on sale that fit my size 11 feet. I usually focused on my face or feet in full length mirrors. It was way too painful to look at my entire body in a mirror, head to toe. Coincidentally, my customers at the restaurant always commented on my earrings or shoes"), _c('span'), _vm._v("too.")]), _vm._v(" "), _c('p', {
    staticClass: "center_img"
  }, [_c('img', {
    attrs: {
      "alt": "qoutes",
      "src": "OEBPS/image/5.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1st-paragraph"
  }, [_vm._v("After digging deeply into my past, I wrote down my less than perfect thoughts about myself that said I wasn’t good enough. I wished I was one of those people who didn’t think about food. I wished I was one of those people who forgets to eat. (My first boyfriend was one of those types.) I wished I was one of those people who just goes without food without realizing it. I burned those wishes and thoughts up in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Negative Thought Pot")]), _vm._v(" with great satisfaction. Then I was able to move on. I was finally successful in my wellness goals. Months later, I was able to enjoy my full reflection with self-love. Other people reacted to my shift in positive ways too. What I thought about, I brought"), _c('span'), _vm._v("about.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("For me, my downfall "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and")]), _vm._v(" my healing arrived with food. Food was my personal starting point. Why? If I feed every cell in my body with the most nourishing, healing, life-giving, vital foods, the cell centers are fed. That, in turn, feeds my brain and body, and I have energy, creativity, and a positive attitude. I truly feel vibrant and vital, with flexibility, agility, and strength. I make choices that are smarter too. I am reading and remembering facts from my research better. My blood work is now in the optimal range rather than in the normal range. I am a happy, healthy"), _c('span'), _vm._v("me.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("This is an example of one root problem that is causing various ruts in the United States of America and beyond. We are the most obese nation on earth, with chronic diseases and conditions related to obesity, that include anxiety, addictions, depression, and other psychological illnesses. Ironically, we have the most diet protocols and supplements for the problem of obesity. Yet, we remain stuck on the hamster wheel. “If only I lost "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("X")]), _vm._v(" number of pounds of fat, my life would be perfect. I would be happy and healthy. Mr. or Ms. Right would fall in love with me and we would live happily ever"), _c('span'), _vm._v("after.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Please allow me to pop the sugary, sweet, and fake bubble you have been sold by the diet industry. Real food works. When you get off the pills and potions you will have to learn how to transition into a real food eating lifestyle for the long term anyway, so I encourage folks to start their journey to body, soul, and mind wellness by eating real"), _c('span'), _vm._v("food.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I have devoted years researching up to date studies on fat loss, hormones, and how nutrient dense foods relate to mental wellness and emotions. My recent area of interest is in studying the function of the intestines, the prebiotics that feed the probiotics which live there, and how the rest of our body and attitude is influenced by a happy or unhappy gut. I have learned about the importance of human touch, essential oil therapy, movement, restorative practices, humor, playing, and connecting daily with people we love. I am passionate about teaching others how to build a tribe of support when changing their lifestyle for the better. I encourage others to seek out and build a community of like minded"), _c('span'), _vm._v("individuals.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("During my years as a life and wellness coach I have developed a shift in eating that slowly takes us away from the Standard American Diet and leads us to the most nutrient-dense eating style that I know. This is the real food eating style I mentioned above. I advocate eating food in the form closest to how God made it, without added colorings, preservatives, or chemicals. Foods like cheese puffs, with their hot pink or orange hue, are not found in nature, either in color, flavor, or"), _c('span'), _vm._v("texture.")]), _vm._v(" "), _c('p', {
    staticClass: "center_img"
  }, [_c('img', {
    attrs: {
      "alt": "qoutes",
      "src": "OEBPS/image/6.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1st-paragraph"
  }, [_vm._v("This shift is not a diet. There are no points and no calories to count. There are no comparisons of carbs to fats to proteins. As stated earlier, this is a nourishing real foods eating lifestyle for the long term meant to sustain and enhance your total wellness in mind, body, and"), _c('span'), _vm._v("soul.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("This guide will help with cravings for junk food and sugary treats. It may not be easy at first, because it may be different than what you have been eating to live thus far. With time, trust in the process, and patience you will find yourself not wanting the foods of the past. They no longer serve you. There is no time limit as to how long each step may take to master. It will take precision. Each day, be mindful and present with each meal. Be precise. That means focus on just that one day, that one meal, that one moment. Say in your head, over and over again, “Just for today.” It will help keep you from feeling overwhelmed. It is entirely up to you. As with any lifestyle change, please check with your health care practitioner before embarking upon "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Superior Self’s Guide to Wellness from")]), _c('em', {
    staticClass: "italic"
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Within.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("In my first book, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Superior Self,")]), _vm._v(" I shared a shift in eating called "), _c('span', {
    staticClass: "bold1"
  }, [_vm._v("Superior Self’s Guide to Wellness from Within")]), _vm._v(". I believe, without a doubt, that if we take care of ourselves with basic, good, real foods, our brains, hearts, and bodies will function in the best way possible for us. This allows us to receive dynamic health and a dynamic life. We will think more clearly. We will sleep better. Our hormonal system will be in better balance. We will heal from drama and trauma with fewer struggles. The intestines, or gut, are now being called the second brain. We need to feed it well. With real food, we may have more of those "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("aha")]), _vm._v(" moments. We will be able to reach for our superior selves. We will be happy and"), _c('span'), _vm._v("healthy.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Superior Self’s Guide to Wellness from Within")]), _vm._v(" is a system of small shifts toward eating the most nutrient dense foods possible. These shifts can be made weekly, monthly, or you can take as long as you need to take, as long as they are made with 100% commitment. The steps in the guide must be done sequentially, and they must build upon each other in order to be successful. Eat local, organic, and in-season foods when you can find them and when it fits your budget to buy them. Here we"), _c('span'), _vm._v("go!")]), _vm._v(" "), _c('p', {
    staticClass: "subheadings"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Superior Self’s Guide to Wellness from Within")]), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fn3"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_029#f3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _c('span', {
    staticClass: "bold"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The plan can be used week by week (or month by month, or"), _c('span'), _vm._v("longer).")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I"), _c('span'), _vm._v("suggest:")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Step 1")]), _vm._v("- Increase water to a gallon a day. Remember to go"), _c('span'), _vm._v("slowly.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Here’s why: Water consumption lubricates our entire body from the inside. It makes the joints less achy and the skin supple and fresh looking. Water assists the digestive system, moving food and their nutrients through the body. Increased water consumption aids in relieving constipation. Fat cells increase or decrease in size, but most humans still have the same number of fat cells in their bodies that they have had since toddlerhood (unless we surgically remove them). When changing food intake to healthier choices, fat cells may very well shrink. Water consumption helps us sweat and urinate more. The more water that goes in, the more water goes out. Drinking lots of water also rids the body of"), _c('span'), _vm._v("toxins.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When we drink lots of water, we may find ourselves satisfied with less food and our impulses to eat junk food fade away. With more water consumption, we can identify if we are truly hungry, or emotionally and socially hungry. I add yummy fresh flavors to pitchers of water in order to help get a gallon of water into my body. I put sliced strawberries and mint leaves in one pitcher, sliced tomatoes and basil leaves in one pitcher, sliced cucumbers and cantaloupe in one pitcher, and lemon, lime, and orange slices in another pitcher. I was at Whole Foods recently and saw a sixteen ounce bottle of cinnamon stick/apple slice water for $6.99. I add electrolyte powder or a pinch of Pink Himalayan salt to the water jug to add extra minerals to my day. Sometimes I have to negotiate with my children about who gets the last glass of water because the water jugs are so"), _c('span'), _vm._v("delicious.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Step 2")]), _vm._v("- Give up all wheat and gluten containing products and continue to drink a gallon of water a"), _c('span'), _vm._v("day.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Here’s why: Wheat and gluten containing products are high on the list of foods that are common allergens to which people are highly sensitive. Most folks do not even know they are sensitive to these foods until they eliminate them from their lifestyle and see remarkable improvements. Wheat and gluten containing products are in many highly processed foods. Most commercial salad dressings have wheat and gluten in them, as well as a host of scientific sounding flavors and additives. Wheat and gluten act like glue in the body and make food “stick to our ribs.” Wheat is one of the crops that has been most altered by the farming"), _c('span'), _vm._v("industries.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Wheat can be inflammatory in the body’s systems. Consistent, chronic inflammation from highly processed, gluten-filled convenience foods can cause obesity and conditions related to obesity. Most people are sensitive to wheat, but don’t realize it. Yet, when they follow my guide and give it up, they find aches, pains, gas, acne, eczema, and bloating fading away. Here are the most common foods containing wheat and"), _c('span'), _vm._v("gluten:")]), _vm._v(" "), _c('table', {
    staticClass: "basic-table",
    attrs: {
      "id": "table-1"
    }
  }, [_c('colgroup', {
    staticClass: "calibre4"
  }, [_c('col', {
    staticClass: "calibre5"
  }), _vm._v(" "), _c('col', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('tbody', {
    staticClass: "calibre6"
  }, [_c('tr', {
    staticClass: "calibre7"
  }, [_c('td', {
    staticClass: "calibre8",
    staticStyle: {
      "width": "50%"
    }
  }, [_c('ul', {
    staticClass: "calibre9"
  }, [_c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("All Wheat"), _c('span'), _vm._v("Types")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Bread")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Cereals")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Pasta")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Cookies")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Pastries")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Pies")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Commercial Salad"), _c('span'), _vm._v("Dressings")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Commercial"), _c('span'), _vm._v("Sauces")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Pre-packaged"), _c('span'), _vm._v("Meals")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Frozen Complete"), _c('span'), _vm._v("Meals")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Soy"), _c('span'), _vm._v("Products")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Couscous")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Crackers")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Beer")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Some Oats"), _c('span', {
    staticClass: "toc-underline",
    attrs: {
      "id": "calibre_toc_8"
    }
  })])])]), _vm._v(" "), _c('td', {
    staticClass: "calibre8"
  }, [_c('ul', {
    staticClass: "calibre9"
  }, [_c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Rye")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Barley")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Gravy")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Cakes")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Muffins")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Flour"), _c('span'), _vm._v("Tortillas")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Modified Food"), _c('span'), _vm._v("Starch")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Some Lunch Meats and Some Hot"), _c('span'), _vm._v("Dogs")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Some Seasoned"), _c('span'), _vm._v("Chips")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Some Imitation Seafood and"), _c('span'), _vm._v("Fish")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Malt")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Matzo")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Some"), _c('span'), _vm._v("Candies")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Bouillon"), _c('span'), _vm._v("Cubes")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Some Croutons and Bread Crumbs"), _c('span', {
    staticClass: "toc-underline",
    attrs: {
      "id": "calibre_toc_9"
    }
  })])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The takeaway message here is that knowledge is power. Start to read ingredient labels if you buy things in boxes. Better yet, have fun in the kitchen and begin to make your own gluten free and wheat free versions of old"), _c('span'), _vm._v("favorites.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_vm._v("If you miss wheat and gluten containing processed foods, there are alternatives. If you love pizza, try a gluten free flour to make your crust. Most restaurants offer a gluten free version nowadays. For salad dressings, I suggest making your own. They are easier than you think. Here is a recipe to get you started on the wheat free and gluten free path. Not only is this recipe wheat free and gluten free, it is completely grain"), _c('span'), _vm._v("free."), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "gray"
  }, [_c('p', {
    staticClass: "recepie-heading"
  }, [_c('span', {
    staticClass: "bold5"
  }, [_vm._v("Cauliflower Crust")]), _c('span', {
    staticClass: "bold5"
  }), _c('span', {
    staticClass: "bold5"
  }, [_vm._v("Pizza")])]), _vm._v(" "), _c('p', {
    staticClass: "recepie-subheading"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('ul', {
    staticClass: "calibre9"
  }, [_c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("•\t")]), _vm._v("2 bags frozen riced cauliflower or 1 giant head of cauliflower ")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("•\t")]), _vm._v("3"), _c('span'), _vm._v("eggs")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("•\t")]), _vm._v("1/2 cup coconut flour (or optionally almond, tapioca, or chestnut"), _c('span'), _vm._v("flour)")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("•\t")]), _vm._v("1/2 cup heavy whipping cream or coconut milk ")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("•\t")]), _vm._v("2 Tablespoons extra virgin olive"), _c('span'), _vm._v("oil")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("•\t")]), _vm._v("1/2 cup butter or coconut"), _c('span'), _vm._v("oil")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("•\t")]), _vm._v("1 cup shredded mozzarella"), _c('span'), _vm._v("cheese")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("•\t")]), _vm._v("1 cup hard Parmesan cheese, grated by"), _c('span'), _vm._v("hand")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("•\t")]), _vm._v("1/2 cup nutritional yeast"), _c('span'), _vm._v("flakes")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("•\t")]), _vm._v("salt and pepper to"), _c('span'), _vm._v("taste")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("•\t")]), _vm._v("garlic powder to"), _c('span'), _vm._v("taste")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("•\t")]), _vm._v("dried oregano to"), _c('span'), _vm._v("taste")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("•\t")]), _vm._v("8 oz. sliced, sundried tomatoes in olive"), _c('span'), _vm._v("oil")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("•\t")]), _vm._v("optional toppings: tomatoes, zucchini, olives, spinach, broccoli, mushrooms, leeks, and other family"), _c('span'), _vm._v("favorites.")])]), _vm._v(" "), _c('p', {
    staticClass: "recepie-subheading"
  }, [_vm._v("Directions:")]), _vm._v(" "), _c('ol', {
    staticClass: "calibre10"
  }, [_c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("1.\t")]), _vm._v("Cook riced cauliflower on stovetop according to directions on the bag. If using the whole head of cauliflower, mash with potato"), _c('span'), _vm._v("masher.")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("2.\t")]), _vm._v("Roll mashed cauliflower in paper towels until all the moisture is out of"), _c('span'), _vm._v("it.")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("3.\t")]), _vm._v("Add eggs, garlic, oregano, and nutritional yeast flakes. Mix"), _c('span'), _vm._v("thoroughly.")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("4.\t")]), _vm._v("Add salt, pepper, and butter or coconut oil. Mix"), _c('span'), _vm._v("thoroughly.")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("5.\t")]), _vm._v("Add coconut flour and mix"), _c('span'), _vm._v("thoroughly.")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("6.\t")]), _vm._v("Add half of the mozzarella and half of the"), _c('span'), _vm._v("Parmesan.")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("7.\t")]), _vm._v("Mix with"), _c('span'), _vm._v("hands.")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("8.\t")]), _vm._v("On a large cookie sheet, spread olive oil on parchment"), _c('span'), _vm._v("paper.")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("9.\t")]), _vm._v("Spread mixture evenly over parchment"), _c('span'), _vm._v("paper.")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("10.\t")]), _vm._v("Bake for 30 minutes at 400° or until bottom of crust is golden"), _c('span'), _vm._v("brown.")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("11.\t")]), _vm._v("Take out of oven and spread the sun-dried tomatoes evenly with a little of their own olive"), _c('span'), _vm._v("oil.")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("12.\t")]), _vm._v("Add remaining cheeses and veggies of your"), _c('span'), _vm._v("choice.")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("13.\t")]), _vm._v("Bake in the oven for another 35 minutes at 400° or until edges are crispy and dark"), _c('span'), _vm._v("brown.")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-numbering"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("14.\t")]), _vm._v("Be creative! Add meats, different sauces, cheeses, and try vegetables you have never tried"), _c('span'), _vm._v("before."), _c('span')])])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Step 3")]), _vm._v("- Give up all grains and continue to drink a gallon of water a"), _c('span'), _vm._v("day.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Here’s why: All grains have to be processed in order to be edible. Those wheat berries, as well as corn, millet, rye, barley, or oats must be picked, dried, split open, or ground. Then we must cook them in order to digest them. The smaller and finer the grind, the higher the glycemic index. Extra fine bakers’ flour has a much higher glycemic index (how much the food affects the blood sugar level) than a wheat berry in its original form even though it is the same wheat. This causes glucose and insulin levels to spike during digestion. The high energy spike is followed by a crash, and then low energy ensues. So, we may reach for another high carbohydrate snack to raise our blood sugar levels again. It is a vicious cycle. The sugar in the blood stream is processed by the liver and if we are not using up the energy right away by exercising, it is readily turned to fat, the kind of fat we do not need or"), _c('span'), _vm._v("want.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("All plant matter turns to glucose in the bloodstream. Cereal, spinach, an orange, or pineapple juice all will be converted into sugar. The rate of absorption is fast or slow depending upon the amount of fiber in the food. Spinach has the most fiber and lowest glycemic index. If you miss starch and want an easy substitute for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("starchy grains")]), _vm._v(" I"), _c('span'), _vm._v("suggest:")]), _vm._v(" "), _c('ul', {
    staticClass: "calibre9"
  }, [_c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Yams")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Sweet"), _c('span'), _vm._v("Potatoes")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Butternut"), _c('span'), _vm._v("Squash")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Acorn"), _c('span'), _vm._v("Squash")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("White"), _c('span'), _vm._v("Potatoes")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Quinoa")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Coconut Oil Prepared Potato"), _c('span'), _vm._v("Chips")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Olive Oil Prepared Potato"), _c('span'), _vm._v("Chips")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Coconut Oil Prepared Sweet Potato"), _c('span'), _vm._v("Chips")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Olive Oil Prepared Sweet Potato"), _c('span'), _vm._v("Chips")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Kale"), _c('span'), _vm._v("Chips")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Plantain"), _c('span'), _vm._v("Chips")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Kabocha"), _c('span'), _vm._v("Squash")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Heirloom"), _c('span'), _vm._v("Carrots")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Parsnips")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Chestnuts")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Turnips")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Rutabaga")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("French Fries, Cooked in Healthy"), _c('span'), _vm._v("Oil")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Sweet Potato Fries, Cooked in Healthy"), _c('span'), _vm._v("Oil")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("For baking I suggest using tapioca, chestnut, coconut, or almond"), _c('span'), _vm._v("flour.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Step 4")]), _vm._v("- Reduce fruits to one to two times a day, while continuing with previous dietary shifts (i.e., no grains and a gallon of water each"), _c('span'), _vm._v("day).")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Here’s why: Fruits these days are sweeter than the ancient wild ones grown without agricultural practices. Thousands of years ago, fruit was eaten when in season and ripe. Our ancestors did not get to eat fruit very often. Today’s fruit growers have perfected uniform colors and sizes in fruit crops. They are also grown to be sweet on purpose. This causes insulin spikes and cravings for more sweet tasting"), _c('span'), _vm._v("things.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The whole point of "), _c('span', {
    staticClass: "bold1"
  }, [_vm._v("Step 4 is to ")]), _c('span', {
    staticClass: "bold-italic1"
  }, [_vm._v("get real.")]), _c('span', {
    staticClass: "bold1"
  }), _vm._v("Most of us do have a sugar problem, but do not see it as such. If you say that you hardly ever eat ice cream or dessert, I believe you. Then we may go over your daily eating diary. I look at breakfast and see coffee with half and half and a plain bagel with butter, a nonfat bagel at that. The bagel turns into glucose in the blood stream because it is highly processed white flour. Then at 10a.m. you had some nonfat strawberry yogurt and carrot sticks and cheese. The strawberry yogurt has added sugar and extra milk sugar to make the nonfat parts taste like milk"), _c('span'), _vm._v("again.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Lunch was a tuna salad sandwich with veggies on whole wheat bread with light mayonnaise and chopped veggies on the side. Mayonnaise is usually made from canola oil which is heated to toxic temperatures to release the oil from the rapeseed. There is a lot of sugar added to mayonnaise. The bread is highly processed and full of gluten and will turn to glucose in the blood stream. You sipped on diet lemonade to top off the meal and added a non fat frozen yogurt for dessert. Sugar substitutes, which are chemically derived, make the brain think we had sugar and cause the liver to react as if we have eaten sugar, so then we crave more"), _c('span'), _vm._v("sugar.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Dinner was at a chain restaurant where they serve menus with calories next to each item. You had the “lite”-fare. What they forgot to share was some key information about the ingredients, like the toxic canola oil, gluten, wheat, and soy, and the 16 teaspoons of sugar in the commercial salad dressing they used on your “lite” salad. The menu omitted the amount of high fructose corn syrup in the BBQ sauce on your breast of pumped up, hormonally dosed chicken. The food industry fooled you (and me) for years, but now we are educating ourselves so we may live optimally and pain free from the inside out, so that we may renew ourselves, body, soul, and"), _c('span'), _vm._v("mind.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("This is the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("get real")]), _vm._v(" moment when I tell you again, “I think we need to reduce your fruits and eventually we will reduce your sugar. Your cravings for carbohydrates from processed foods and sugary foods will fade with time. You have to trust the process and honor your precise"), _c('span'), _vm._v("efforts.”")]), _vm._v(" "), _c('p', {
    staticClass: "center_img"
  }, [_c('img', {
    attrs: {
      "alt": "qoutes",
      "src": "OEBPS/image/7.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1st-paragraph"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Step 5")]), _vm._v("- Reduce fruits to one to two servings a week. ")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1st-paragraph1"
  }, [_vm._v("Here’s why: Once we are able to conquer the fruit reduction to 1-2 times a day, it is time to lessen our fruit intake even more. I suggest the following substitutes for"), _c('span'), _vm._v("fruit:"), _c('span')]), _vm._v(" "), _c('ul', {
    staticClass: "calibre9"
  }, [_c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Carrots ")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Raw Shredded"), _c('span'), _vm._v("Coconut")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Fennel ")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Sweet Potatoes ")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Sweet Peppers ")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Winter"), _c('span'), _vm._v("Squash")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Raw Chocolate ")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Cheeses")]), _vm._v(" "), _c('li', {
    staticClass: "bodytext-bullets-split"
  }, [_c('span', {
    staticClass: "char-style-override1"
  }, [_vm._v("•\t")]), _vm._v("Nuts and their"), _c('span'), _vm._v("Butters")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Reach for high fat foods instead of high sugar foods. This will keep blood sugar levels more even throughout the day. You may find yourself not wanting fruits or sweet vegetables very often after curtailing sweet produce consumption for a few"), _c('span'), _vm._v("weeks.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Step 6")]), _vm._v("- Change your oils and fats to only healthy dietary fats like extra virgin olive oil, raw grass-fed dairy, grass fed fatty meats, avocados, raw tree nuts and butters, and minimally processed coconut"), _c('span'), _vm._v("products.")]), _vm._v(" "), _c('p', {
    staticClass: "center_img"
  }, [_c('img', {
    attrs: {
      "alt": "qoutes",
      "src": "OEBPS/image/8.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1st-paragraph"
  }, [_vm._v("Here’s why: Fats and oils from minimally processed foods will provide energy for hours, and they produce a super satisfying, creamy mouth feel. My favorite afternoon pick-me-up is raw butter, raw milk cheese, and homemade sugar free preserves on a grain-free flax cracker. The high omega-3 oils and lots of healthy fats provide mental focus and"), _c('span'), _vm._v("clarity.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I eat a high fat diet and stay slim. Healthy fats help us absorb the vitamins, minerals, and phytochemicals from the vegetables we eat with them. I put raw butter or extra virgin olive oil on my steamed and oven roasted veggies, my grass fed and grass finished meats, my wild fish, and my wild caught seafood. The only nut I eat roasted is the peanut because it is actually a bean (most beans and legumes are better absorbed by the body when"), _c('span'), _vm._v("cooked).")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Fats are not found in nature all by themselves. They are bound to something else. For example, meat has fat in and around it; avocados have flesh with both fiber and fat, and olives do as well. Butter, cheeses and oils are made after milking, crushing, fermenting, and so forth. We don’t go walking in the woods and suddenly come upon a clearing and say to our hiking partner, “Look, a field of butter! Let’s pick it and eat it!” Oils and fats are best absorbed and utilized by the body when eaten in their whole form. The body is natural and whole. The whole food form is natural and whole. Natural understands natural. The whole food form is minimally processed when compared to the oil form so the nutrients are more bioavailable to the body. When available and affordable, I encourage folks to eat avocado as well as consume avocado oil. I suggest you eat olives and enjoy extra virgin olive oil. Does this make"), _c('span'), _vm._v("sense?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Here are a few oils and fats I"), _c('span'), _vm._v("recommend:")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Extra Virgin Olive Oil: Use at room temperature and toss in after the veggies are done or use when roasting foods in the oven. If sautéing on the stovetop keep food temperatures less than 450 degrees so that the heat does not cause smoking and the molecules of the fat do not change. When oils and fat molecules get overheated, past their smoke point, the good qualities of the dietary fat are lost and the healthy fat becomes something else"), _c('span'), _vm._v("entirely.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Grape Seed Oil: Use as a neutral oil for any recipe because it has no flavor or odor. It is great for salad dressings and sauces. It is mostly poly-unsaturated fat and should not be heated, even though it has a high smoke"), _c('span'), _vm._v("point.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Coconut Oil and Palm Oil: Use at any temperature, but be aware that it will harden at room temperature. I use coconut oil for my skin and hair, as well as for cooking at high heat, making baked goods, frying, thickening sauces, oiling the furniture, whitening my teeth, and"), _c('span'), _vm._v("more.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Butter, rendered lard, duck fat, rendered beef tallow, and rendered chicken fat: Use freely at varied temperatures, sticking to grass fed and raw, unpasteurized butter when you can afford it and when you can find it in your area. These all have a high temperature smoke"), _c('span'), _vm._v("point.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Ghee: Use ghee if you are sensitive to the milk proteins in butter. It has the good fats with most of the casein milk protein skimmed off of the"), _c('span'), _vm._v("top.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Nut and Seed Oils: Depending on the nut or seed, the smoke point and the mono-unsaturated, poly-unsaturated, or saturated bond of the fat molecule is different for each. Please do your research before cooking. When in doubt, toss oils on after cooking for flavor and health"), _c('span'), _vm._v("benefits.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("If you want to dig deeper into the world of dietary fats, I highly recommend looking"), _c('span'), _vm._v("at:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "href": "https://healyeatsreal.com/",
      "target": "_blank"
    }
  }, [_vm._v("http://www.healthyeatsreal.com")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "href": "http://www.eatnakednow.com",
      "target": "_blank"
    }
  }, [_vm._v("http://www.eatnakednow.com")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "href": "http://www.realfoodkosher.com",
      "target": "_blank"
    }
  }, [_vm._v("http://www.realfoodkosher.com")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text-indent"
  }, [_c('a', {
    attrs: {
      "href": "http://www.pubmed.gov",
      "target": "_blank"
    }
  }, [_vm._v("http://www.pubmed.gov")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Step 7")]), _vm._v("- No more added sugar, in any form: no honey, agave, or date"), _c('span'), _vm._v("sugar.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Here’s why: Some sugar substitutes that are sweet, but made from chemicals (and some that are from natural sources) still make our brains and bodies think we have had sugar. This triggers cravings. Remember that sweets are treats, not to be indulged in daily, even if they are natural. I can easily eat a one pound box of dates in about 15 minutes. How about"), _c('span'), _vm._v("you?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_vm._v("You have progressed almost all the way through the Guide. "), _c('span', {
    staticClass: "bold1"
  }, [_vm._v("Steps 4 and 5")]), _vm._v(" were the biggest challenges by far for most of you. This one should be a breeze. You are off the hamster wheel of sugar in its secret"), _c('span'), _vm._v("disguises."), _c('span')]), _vm._v(" "), _c('p', {
    staticClass: "center_img"
  }, [_c('img', {
    attrs: {
      "alt": "qoutes",
      "src": "OEBPS/image/9.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1st-paragraph"
  }, [_vm._v("What I have found to be true for myself and for most of my coaching clients is that we slowly use less and less of the sweet natural substitutes until we use nothing in our coffee or tea. I rarely eat fruit, perhaps four times a year, only when I crave it. When I crave fruit I do not deny myself. I am truly listening to my body’s needs. If I crave it I must need a vitamin, mineral, enzyme, or chemical from it that I am lacking. I went a year without a banana one time. Then one afternoon not too long ago, I saw bananas on the kitchen table and quietly but urgently ate three. My husband’s eyes widened and he said, “Are you okay?” I replied, “Yes, I guess I needed a banana.” Eating real food and eating clean for over five years has afforded me the ability to listen to my body very well. Free at"), _c('span'), _vm._v("last.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Buy the natural sugar alternatives Lakanto or XYLA on line or at health food stores. Lakanto is Chinese monk fruit dried and crystallized. It is used in Asia for lung issues, liver ailments, circulation, sore throats, and preventing a host of other illnesses. I like the golden brown variety of Lakanto. I buy Lakanto on the internet. Xyla is a natural white sugar alternative from the bark of the birch tree. I buy Xyla from a health food store. I use these natural sugar substitutes in my beverages and in marinades, dressings, sauces, and for"), _c('span'), _vm._v("baking.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_vm._v("When you want a treat, it is not a cheat. There is no self induced guilt here (and all guilt is truly self-induced). I believe in the 80/20 rule. That means if I eat clean and green 80 percent of the time I can party like a rock star 20 percent of the time. What you consistently practice 80 percent of the time shows up in your life 100 percent of the time. After years of clean eating my party choices aren’t regularly gluten-filled, sugary chocolate cakes. The party looks more like a Manhattan cocktail and the following recipe. Enjoy this sugar free and grain free dessert recipe my daughter Sage (age 11 at the time) and I"), _c('span'), _vm._v("created:"), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "gray"
  }, [_c('p', {
    staticClass: "recepie-heading"
  }, [_c('span', {
    staticClass: "bold5"
  }, [_vm._v("Chocolate Bark, Fondue, and Truffle")]), _c('span', {
    staticClass: "bold5"
  }), _c('span', {
    staticClass: "bold5"
  }, [_vm._v("Base")])]), _vm._v(" "), _c('p', {
    staticClass: "recepie-subheading"
  }, [_vm._v("Ingredients:")]), _vm._v(" "), _c('ul', {
    staticClass: "calibre9"
  }, [_c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("•\t")]), _vm._v("6 Tablespoons salted"), _c('span'), _vm._v("butter")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("•\t")]), _vm._v("1/4 cup Xyla or Lakanto (natural"), _c('span'), _vm._v("sweeteners)")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("•\t")]), _vm._v("2 Tablespoons coconut"), _c('span'), _vm._v("milk")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("•\t")]), _vm._v("1 4-ounce bar of 100% chocolate, broken into pieces (you may use raw chocolate if you"), _c('span'), _vm._v("want)")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("•\t")]), _vm._v("Extra heavy whipping cream if you want less dark chocolate as the end result. Sometimes we will make dark milk chocolate, extra dark chocolate, and black chocolate truffle varieties in the same"), _c('span'), _vm._v("day.")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("•\t")]), _vm._v("Optional Add-Ins: dried fruits, fruits, shredded coconut, cayenne or chili pepper, smoked paprika, cinnamon, nutmeg, pumpkin pie spice, vanilla, nuts, seeds, vegetables, dehydrated vegetables, etc.")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("•\t")]), _vm._v("Mini cupcake paper"), _c('span'), _vm._v("liner")])]), _vm._v(" "), _c('p', {
    staticClass: "recepie-subheading"
  }, [_vm._v("Directions:")]), _vm._v(" "), _c('ol', {
    staticClass: "calibre10"
  }, [_c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("1.\t")]), _vm._v("Put a small pan or small soup pot on medium"), _c('span'), _vm._v("heat.")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("2.\t")]), _vm._v("Add the butter and sweetener to"), _c('span'), _vm._v("pot.")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("3.\t")]), _vm._v("Stir until sweetener completely"), _c('span'), _vm._v("dissolves.")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("4.\t")]), _vm._v("Add coconut milk and stir"), _c('span'), _vm._v("vigorously")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("5.\t")]), _vm._v("Add chocolate"), _c('span'), _vm._v("pieces.")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("6.\t")]), _vm._v("As the chocolate begins to melt, reduce heat to low and continue stirring until"), _c('span'), _vm._v("smooth.")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("7.\t")]), _vm._v("Sometimes the chocolate is completely melted and mixed in, but has a grainy look within the smoothness, that is fine. It depends on the country of the chocolate’s"), _c('span'), _vm._v("origin.")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("8.\t")]), _vm._v("Once everything is done melting, you are ready to"), _c('span'), _vm._v("enjoy!")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("9.\t")]), _vm._v("For fondue, leave the pot on the lowest simmer setting or on the table if the room is warm. Add extra heavy whipping cream to the pot if the desired result is less dark, experiment to your"), _c('span'), _vm._v("tastes.")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("10.\t")]), _vm._v("Begin dipping your fruit or vegetables into the chocolaty goodness. ")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("11.\t")]), _vm._v("For adventurous types, try dipping broccoli or carrots into the"), _c('span'), _vm._v("fondue!")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("12.\t")]), _vm._v("For truffles, use a teaspoon and drop a teaspoon or more of the chocolate into mini candy molds or mini cupcake"), _c('span'), _vm._v("liners.")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("13.\t")]), _vm._v("Press shredded coconut, nuts, or dried fruits on"), _c('span'), _vm._v("top.")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("14.\t")]), _vm._v("Place in freezer at least one hour. Makes 18"), _c('span'), _vm._v("truffles.")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("15.\t")]), _vm._v("For bark, line a cookie sheet with parchment"), _c('span'), _vm._v("paper.")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-bullet"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("16.\t")]), _vm._v("Place nuts, seeds, or dried fruits on paper, then pour chocolate on top evenly covering the"), _c('span'), _vm._v("goodies.")]), _vm._v(" "), _c('li', {
    staticClass: "recepie-text-numbering"
  }, [_c('span', {
    staticClass: "char-style-override2"
  }, [_vm._v("17.\t")]), _vm._v("Freeze at least an hour. Enjoy."), _c('span')])])]), _vm._v(" "), _c('p', {
    staticClass: "center_img"
  }, [_c('img', {
    attrs: {
      "alt": "qoutes",
      "src": "OEBPS/image/10.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1st-paragraph"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Step 8")]), _vm._v("- Purchase raw dairy and pasture-raised eggs if you regularly consume dairy and eggs. Pasture-raised eggs are eggs from chickens who aren’t fed grains, and are free to roam about to eat bugs, worms, fruits, grasses, and"), _c('span'), _vm._v("vegetables.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1st-paragraph"
  }, [_vm._v("Here’s why: Raw dairy and 100% pasture-raised eggs may not cause the same reaction to the body as products from grain fed animals. If you are sensitive to dairy and grains I suggest trying baby steps and tread lightly with this one. On an empty stomach try one taste of one product that is the highest quality and not factory farmed, make sure that they are 100% grass fed dairy and unpasteurized. If eggs, make certain they are not fed grains and that they are 100% pastured, and not fed hormones and antibiotics. My own experience is that I no longer suffer from constipation or rashes when I eat raw milk, cream, and cheeses. The pastured eggs just taste better, although I never had any sensitivity to"), _c('span'), _vm._v("eggs.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Remember, if you consume animal products, you eat what the animal ate. If an animal does not have grains in its natural diet and we give it grains, antibiotics, and growth hormones, it may suffer allergies, bloating, obesity, stress, illness, etc. When we eat an animal, its milk, or its offspring, we may literally eat the stress and illness, or suffer the resulting effects from the hormones and medicines the farmers feed them. They suffer, we suffer. They stress, we stress. They get fat, we get fat. They are ill, we are ill. Everything is"), _c('span'), _vm._v("connected.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I know pastured eggs are more expensive than regularly produced eggs. I know raw milk and cheeses are costly when compared to pasteurized, processed cheeses. You have just given up all grains, fruits, and sugars. You no longer have processed foods in your cupboards. There are no sodas, breads, pies, cakes cookies, cereal, pasta, crackers, chips, corn chips, tortillas, ice cream, or pizzas in the house. Cereal is upwards of $5.00 a box. With the money you have been saving throughout the steps thus far, you may afford a higher quality food supply or go on a higher quality"), _c('span'), _vm._v("vacation.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "bold1"
  }, [_vm._v("Step 9")]), _vm._v("- Give up beans and"), _c('span'), _vm._v("legumes.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Here’s why: Beans and legumes are high starch and must be soaked overnight and then cooked to release the gaseous property. They have a hard endosperm covering which must be broken down in order to be absorbed by the body. For years the media has promoted beans as high protein, but most beans and legumes have about 30% protein. Mostly beans are carbohydrates, which raises blood sugar. I tend to steer clear of them for my tummy’s"), _c('span'), _vm._v("sake.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When I crave a bean-like texture I eat roasted chestnuts, already shelled. They are so delicious and nutritious. Lucky for me, they are readily available in stores in Northern"), _c('span'), _vm._v("California.")]), _vm._v(" "), _c('p', {
    staticClass: "glyphs"
  }, [_c('img', {
    staticClass: "frame5",
    attrs: {
      "alt": "16682.png",
      "src": "OEBPS/image/16682.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1st-paragraph"
  }, [_vm._v("In all of the steps, pay particular attention to how you feel rather than how you look. Sometimes flu and cold symptoms, headaches, and general fatigue may plague you. You may suffer acne or a rash for a little while. These are symptoms of the body detoxifying and getting used to the cleaner fuel you are providing it with. Fear not, and keep moving forward with the process. Moving toward superior health can spur us on to our true self. Just think about how clear, attentive, helpful, and generous you can be towards others you love after you have taken care of your own essential biochemical needs. It’s not about the food, although your relationship with food tends to become healthier overall. It’s about a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Happy, Healthy, You.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("This guide is an example of methodical action. You can use this example for any goal in mind. Work at a pace where you can just keep going. Make it a survival pace at first. When we first attempt things unfamiliar to us, they seem impossible. Take one step. Perfect that one step. Own it. The boundaries and limits have just been moved a bit farther past what you formerly thought was doable. Then take the second step. Before you know it you are leaping ahead in your life in all facets because you took the first step and didn’t give"), _c('span'), _vm._v("up.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("After you have completed "), _c('span', {
    staticClass: "bold1"
  }, [_vm._v("Superior Self’s Guide to")]), _vm._v(" "), _c('span', {
    staticClass: "bold1"
  }, [_vm._v("Wellness from Within")]), _vm._v(" on your own terms and on your own time frame, your palate will change. You will see food as fuel. Real food will taste enhanced and will be more delicious than ever. Your internal self will shift as well. You will be emotionally more even because there will be none of those chemical additives and preservatives messing with your pleasure hormones in the"), _c('span'), _vm._v("brain.")]), _vm._v(" "), _c('p', {
    staticClass: "center_img"
  }, [_c('img', {
    attrs: {
      "alt": "qoutes",
      "src": "OEBPS/image/11.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1st-paragraph"
  }, [_vm._v("Most psychiatric patients are also dealing with digestive disorders."), _c('sup', {
    staticClass: "superscript"
  }, [_c('a', {
    attrs: {
      "id": "fn4"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/HappyHealthyYou_split_029#f4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" There is a link between mental illness symptoms and the intestinal bacteria being out of balance. When we have a toxic intestine, there are weak walls. The toxic bacteria can permeate (get through) the walls. The toxic bacteria are then carried throughout the entire body by the blood. This may create a river of mental and physiological problems. We may feel out of sorts, physically ill, and mentally stuck. Depression, a sense of being overwhelmed, and a host of other disorders may prevail, keeping us paralyzed. So, how can we heal and move forward? Nourishing ourselves with a variety of real, whole foods is a great start. Replanting the intestines with fermented foods that contain probiotics adds another layer of healing. Consuming naturally raw, fermented foods like raw sauerkraut, plain Greek yogurt, and kefir are a good place to begin. They add good bacteria back into the body and reduce levels of toxicity, while building immunity. A dietary overhaul is part of a holistic approach to healing, in body and in"), _c('span'), _vm._v("mind.")]), _vm._v(" "), _c('p', {
    staticClass: "quote"
  }, [_c('span', {
    staticClass: "bold-italic"
  }, [_vm._v("“Let food be thy medicine and medicine be thy food.”  ")])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("—Hippocrates")]), _vm._v(" "), _c('p', {
    staticClass: "glyphs"
  }, [_c('img', {
    staticClass: "frame5",
    attrs: {
      "alt": "16682.png",
      "src": "OEBPS/image/16682.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center_img"
  }, [_c('img', {
    attrs: {
      "alt": "qoutes",
      "src": "OEBPS/image/12.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1st-paragraph"
  }, [_vm._v("We can improve our lives, no matter what our current circumstances are. I know this sounds hard to believe, especially when we feel like we have been through hell, but it is the absolute"), _c('span'), _vm._v("truth.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1st-paragraph"
  }, [_vm._v("It may take a billion baby steps, but baby steps are steps, after all! Tiny improvements are positive affirmations of what we humans are capable of"), _c('span'), _vm._v("overcoming.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("How we think about ourselves affects how other people think about us. What we think about, we bring about. I have heard this phrase in so many ways and from so many people, but it didn’t touch my life personally until I heard it from my mentor, Colin F. Watson, my health and life coach. He came into my life while I was working on my own mid-life wellness goals, when I felt"), _c('span'), _vm._v("stuck.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Colin said the self-loathing we exude when we pass a mirror, glance at our reflection, and mentally criticize ourselves is the reason why our fat loss and fitness goals may not be realized. We may work out and eat well, but negative internal dialogue, when combined with daily stress, lack of sleep, and modern anxieties acts like a dam in the waterfall. We then may cheat on our actions related to our other life goals because, “Who are we kidding anyway? We failed so many times"), _c('span'), _vm._v("before.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The inner critic pops into our heads all the time, every day. It is natural to have this visitor. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("It’s just not the truth.")]), _vm._v(" Somehow we got frozen. We can also get unfrozen. With self-love and making sure we take care of our heart first, we can cure the internal self-loathing. We can feel fully awesome and capable of doing anything"), _c('span'), _vm._v("again.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I want to tell you a story about self-love silencing the inner critic, and instead saying "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("thank you")]), _vm._v(", all day"), _c('span'), _vm._v("long.")]), _vm._v(" "), _c('p', {
    staticClass: "glyphs"
  }, [_c('img', {
    staticClass: "frame5",
    attrs: {
      "alt": "16682.png",
      "src": "OEBPS/image/16682.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "headings"
  }, [_c('span', {
    staticClass: "lowercase"
  }, [_vm._v("Graces’s Story: no whining or complaining despite cancer")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1st-paragraph"
  }, [_vm._v("Grace and Chuy were regulars at my hotel restaurant. They were in their seventies and loved to sit next to each other instead of across from each other while eating. Chuy would squish himself into the tiny booth for two, next to Grace, practically sitting on his wife’s knee. One evening while enjoying dinner, he explained why. “I have a short umbilical cord connecting me to my wife,” he lovingly explained, as he gestured from his belly towards his wife’s, pointing with his long elegant"), _c('span'), _vm._v("fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A few minutes later I brought them their half-chicken dinner to share. Chuy reluctantly moved across the table to his own single seat to eat dinner, knowing full well that by dessert he would be sitting next to Grace and sharing a small dessert that required no sharp knives nor hot cast iron"), _c('span'), _vm._v("skillets.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Why do you have such a short umbilical cord?” I"), _c('span'), _vm._v("asked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“We met when we were fifteen years old. We have been together ever since. About five years ago, Grace got cancer. Through her cancer treatments, I still had to work [Chuy works for a fine chocolate company]. I went with Grace to chemotherapy when I could, but it was after each treatment that we had our healing time together. I would tell her to bring it in, meaning come and hold me, tummy to"), _c('span'), _vm._v("tummy.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Whatever pain, nausea, fear, worry, uncertainty, and negative thoughts Grace experienced dissipated. Even now, they have "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("bring it in")]), _vm._v(" moments daily, and Grace is celebrating five years cancer free. The umbilical cord expression makes sense to me"), _c('span'), _vm._v("now.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Grace further explained, “I was always a praying individual with a good attitude. I listened to my body very well. I stayed busy, but if I needed rest, I rested. I didn’t pray to God to heal me from cancer. I prayed to God in gratitude. I said thanks for the person who mopped the floor to make my chemotherapy room sanitary and safe. I prayed thank you to God for creating a warm and loving environment for my treatments. I prayed a prayer of gratitude for the nurses choosing a career path they love and are passionate about. I prayed a prayer of thanks for the doctors to do their jobs well and with compassion. I prayed that God would bestow comfort and courage to the mothers in the neighboring rooms who were caring for their children here with chemotherapy, yet also neglecting their other children at home because of their"), _c('span'), _vm._v("situation.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Grace didn’t ask or beg for her cancer to be healed. She didn’t have a death wish, she told me. Grace had days full of thankfulness, with a wide smile and pep in her step. She didn’t feel like God was punishing her for eating junk food during her early years. She just was not ready for the pity party. She was not one to cry and ask over and over again, “Why me?” Not that the question isn’t valid, but it does not move one forward. Grace wanted to move forward and wanted to find the small steps toward healing through grace, literally and figuratively. She really lived up to her name. Grace created a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Happy, Healthy")]), _c('em', {
    staticClass: "italic"
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("You.")])]), _vm._v(" "), _c('p', {
    staticClass: "glyphs"
  }, [_c('img', {
    staticClass: "frame5",
    attrs: {
      "alt": "16682.png",
      "src": "OEBPS/image/16682.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center_img"
  }, [_c('img', {
    attrs: {
      "alt": "qoutes",
      "src": "OEBPS/image/13.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1st-paragraph"
  }, [_vm._v("Self doubt has a crippling effect on everything we do. It can seep into our bones like arthritis, little bit by little bit. At first, we can take an aspirin or ibuprofen to stave it off, but as it takes over our body, we give in to it. No. I say, no. Then, after the positive work, using the tools throughout this book and after we shift, when we pass a mirror or store window, and notice our reflection, we can smile, nod, and say in our heads, “Hello, fabulous!”.")]), _vm._v(" "), _c('p', {
    staticClass: "glyphs"
  }, [_c('img', {
    staticClass: "frame5",
    attrs: {
      "alt": "16682.png",
      "src": "OEBPS/image/16682.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "headings"
  }, [_c('span', {
    staticClass: "lowercase"
  }, [_vm._v("An Invitation: less than perfect")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1st-paragraph"
  }, [_vm._v("Breaking someone down with tough love doesn’t always make them stronger. Sometimes it just breaks them down. Write down three things that you hold in your mind and body that tell you that you aren’t good"), _c('span'), _vm._v("enough.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Write down the age that you first felt this way. Put the paper into the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Negative Thought Pot")]), _vm._v(". Set it on fire and watch it burn to ashes. Boom! Gone. Smile."), _c('span', {
    staticClass: "bold1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "glyphs"
  }, [_c('img', {
    staticClass: "frame5",
    attrs: {
      "alt": "16682.png",
      "src": "OEBPS/image/16682.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "headings"
  }, [_c('span', {
    staticClass: "lowercase"
  }, [_vm._v("An Invitation: mirror positivity and grace")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1st-paragraph"
  }, [_vm._v("Go stand directly in front of a mirror. Smile at yourself. Observe your smile, your teeth, and your twinkling eyes. Say to yourself out loud, but quietly, “Thank you for all the miraculous things you do for me every day. I love and respect"), _c('span'), _vm._v("you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Do this again tomorrow, and the day"), _c('span'), _vm._v("after…")]), _vm._v(" "), _c('p', {
    staticClass: "glyphs"
  }, [_c('img', {
    staticClass: "frame5",
    attrs: {
      "alt": "16682.png",
      "src": "OEBPS/image/16682.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1st-paragraph"
  }, [_vm._v("We tend to generalize about ourselves in terms of self-judgment, just as much as we generalize about others. I feel this is dangerous because we are constantly changing and evolving as humans. What was true about me a week ago, or even a moment ago, may not necessarily be true right"), _c('span'), _vm._v("now.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When we look at the facts and our beliefs, we can see how one influences the other. For example, my legs are long. Physically, I will not be able to have my eyebrows touch my toes when stretching in the “eyes to toes” yoga pose. But if I keep telling myself that one day I will do it, I will make the effort to stretch deeper and deeper into the pose and go further than I ever have before. After all, it is the goal and the name of the pose. My belief changed the length of the stretch over time. Never say"), _c('span'), _vm._v("never.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Our perceptions and others’ perceptions of the facts can influence us in positive ways, even when they are completely false! When I saw Oprah complete her first marathon at age forty, I decided right then and there that when I turned forty, I would be mature enough, and have enough mental strength, endurance, and power to run a marathon. So, a day or so before my fortieth birthday I ran and completed my first marathon. (Since then, I have completed sixteen"), _c('span'), _vm._v("marathons.)")]), _vm._v(" "), _c('p', {
    staticClass: "center_img"
  }, [_c('img', {
    attrs: {
      "alt": "qoutes",
      "src": "OEBPS/image/14.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1st-paragraph"
  }, [_vm._v("My daughter was a toddler at the time. When she saw the crowd, music, balloons, and fanfare as they announced my name crossing the finish line, she thought I won the marathon, taking first place. I had a medal, tee shirt, and food as gifts too. Her believing I won made it so in her world. The facts and the beliefs worked together in assisting me in accomplishing my goals. They are powerful tools. Since then, every time I get near the end of a race, when I hear my name, see the balloons, and music is blaring, I feel like I have won. I get emotional and teary eyed. I feel immensely grateful for my heart, arms, legs, and life. Thanks, Oprah.")]), _vm._v(" "), _c('p', {
    staticClass: "glyphs"
  }, [_c('img', {
    staticClass: "frame5",
    attrs: {
      "alt": "16682.png",
      "src": "OEBPS/image/16682.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Just recognizing that beginning spot, the root of our rut, is awareness. It is an opening of the exit door with the exit light illuminated. Push the exit door open further and step on through. You "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are")]), _vm._v(" good enough. You are "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("more")]), _vm._v(" than good enough. You "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("shine.")]), _vm._v(" You "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("more")]), _vm._v(" than shine. If nobody shared that with you before, allow me to do that now. You "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("are")]), _vm._v(" the illumination that lights up your own universe, as well as the lives of others. Do not rely on others to tell you so. Sometimes, ancient, hidden memories can be triggered by something seemingly unrelated to them in our current life. When the floodgate of recollections opens up, try not to suppress them. They are a gift to you now, so that you may begin to deal with them, learn from them, and heal from them. Facing our difficulties "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("does")]), _vm._v(" make us"), _c('span'), _vm._v("stronger.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("I believe in the power of humans to sparkle, glitter, shine, spread love, and exude positive thoughts. This is despite the crises that have happened to us in our past. I witness the sparkle every day in the very busy hotel restaurant where I work. Strangers touch my heart with simple gestures, inspirational stories, and wisdom-filled memories shared. I watch as disharmony shifts into harmony amongst families on their vacations to San Francisco. I am a fly on the wall at anniversaries, weddings, and the breathtaking, “Will you marry me?” Conversations with my guests give me continued hope of conquering our demons, our pasts, and what paralyzes"), _c('span'), _vm._v("us.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When we do these written and active exercises, we can have the inside out approach to healing. We can heal from the negative self-talk and from the childhood beliefs of being "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("less than")]), _vm._v(". We can get to the root of the"), _c('span'), _vm._v("rut")]), _vm._v(" "), _c('p', {
    staticClass: "glyphs"
  }, [_c('img', {
    staticClass: "frame5",
    attrs: {
      "alt": "16682.png",
      "src": "OEBPS/image/16682.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "headings"
  }, [_c('span', {
    staticClass: "lowercase"
  }, [_vm._v("Fuel, Focus, F")]), _vm._v("oundation"), _c('span', {
    staticClass: "lowercase"
  })]), _vm._v(" "), _c('p', {
    staticClass: "center_img"
  }, [_c('img', {
    attrs: {
      "alt": "qoutes",
      "src": "OEBPS/image/15.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext-1st-paragraph"
  }, [_vm._v("Food as "), _c('span', {
    staticClass: "bold1"
  }, [_vm._v("fuel")]), _vm._v(" is an important viewpoint as we end this chapter. If you didn’t have to think about what you are going to eat for breakfast, lunch and dinner anymore and you weren’t ruled by fake foods, food would be just fuel, like gas in the fuel tank of your car. If you had food freedom, would you find other sorts of emotional freedom? What bonds would you break free"), _c('span'), _vm._v("from?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Food as "), _c('span', {
    staticClass: "bold1"
  }, [_vm._v("focus")]), _vm._v(" is an important viewpoint as we end this chapter. If you could focus on your other goals in life once you attained food freedom, what would they be? What unique imprint would you impress upon the earth? What would your legacy"), _c('span'), _vm._v("be?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Food as "), _c('span', {
    staticClass: "bold1"
  }, [_vm._v("foundation ")]), _vm._v("is an important viewpoint as we end this chapter. Are you a stronger human being now that you know the interconnectedness of the intake of substances from the earth and the relationship between the foods we eat, the beliefs we have, our attitude, and our past"), _c('span'), _vm._v("experiences?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text1"
  }, [_vm._v("Food as "), _c('span', {
    staticClass: "bold1"
  }, [_vm._v("fuel")]), _vm._v(", f"), _c('span', {
    staticClass: "bold1"
  }, [_vm._v("ocus")]), _vm._v(","), _c('span', {
    staticClass: "bold1"
  }), _vm._v("and"), _c('span', {
    staticClass: "bold1"
  }, [_vm._v(" foundation")]), _vm._v(" work together in supporting a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Happy, Healthy")]), _c('em', {
    staticClass: "italic"
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("You.")]), _c('em', {
    staticClass: "italic"
  })]), _vm._v(" "), _c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "calibre_pb_9"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f0af57e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/HappyHealthyYou_split_009.vue
// module id = 87
// module chunks = 0